import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import verificandoApp from '../../../FuncoesGerais/verificaApp';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { fetchTiposChamadoTodos, createTipoChamado, updateTipoChamado, deleteTipoChamado, fetchCategoriasTodos, duplicarTiposChamadoParaEmpresa } from '../../../api/cadastroChamados';
import { fetchEmpresas } from '../../../api/empresas';
import { ModalConfirm } from '../../Components/ModalSistema';
import CadastroFormDrawer from '../../Components/CadastroFormDrawer/CadastroFormDrawer';
import './tiposChamado.css';

const isEmpresa1 = () => localStorage.getItem('empresa_id') === '1' || localStorage.getItem('isSoftbridge') === 'S';

function TiposChamado() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [nome, setNome] = useState('');
    const [descricao, setDescricao] = useState('');
    const [categoriaId, setCategoriaId] = useState('');
    const [codigoLegado, setCodigoLegado] = useState('');
    const [ativo, setAtivo] = useState(1);
    const [ordem, setOrdem] = useState(0);
    const [usaSprint, setUsaSprint] = useState(0);
    const [emoji, setEmoji] = useState('');
    const [corCard, setCorCard] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [mensagemTipo, setMensagemTipo] = useState('danger');
    const [busca, setBusca] = useState('');
    const [filtroAtivo, setFiltroAtivo] = useState('todos');
    const [formDrawerOpen, setFormDrawerOpen] = useState(false);
    const [showModalDuplicar, setShowModalDuplicar] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [empresaDestinoId, setEmpresaDestinoId] = useState('');
    const [empresasList, setEmpresasList] = useState([]);
    const [loadingDuplicar, setLoadingDuplicar] = useState(false);
    const [mensagemDuplicar, setMensagemDuplicar] = useState('');
    const [confirmExcluir, setConfirmExcluir] = useState({ show: false, itemId: null, itemNome: '' });
    const [confirmDuplicar, setConfirmDuplicar] = useState({ show: false, count: 0, nomeEmpresa: '' });

    const verificar = async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    };

    const load = async () => {
        setLoading(true);
        verificandoToken();
        try {
            const [list, cats] = await Promise.all([fetchTiposChamadoTodos(), fetchCategoriasTodos()]);
            setData(list);
            setCategorias(Array.isArray(cats) ? cats : []);
        } catch (e) {
            setMensagem('Erro ao carregar lista');
            setData([]);
            setCategorias([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        verificar();
        load();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const limparForm = () => {
        setId('');
        setNome('');
        setDescricao('');
        setCategoriaId('');
        setCodigoLegado('');
        setAtivo(1);
        setOrdem(0);
        setUsaSprint(0);
        setEmoji('');
        setCorCard('');
        setMensagem('');
    };

    const handleEdit = (item) => {
        setId(item.id);
        setNome(item.nome || '');
        setDescricao(item.descricao || '');
        setCategoriaId(item.categoria_id != null ? String(item.categoria_id) : '');
        setCodigoLegado(item.codigo_legado != null ? String(item.codigo_legado) : '');
        setAtivo(item.ativo != null ? Number(item.ativo) : 1);
        setOrdem(item.ordem != null ? Number(item.ordem) : 0);
        setUsaSprint(item.usa_sprint != null ? Number(item.usa_sprint) : 0);
        setEmoji(item.emoji != null ? String(item.emoji) : '');
        setCorCard(item.cor_card != null ? String(item.cor_card) : '');
        setMensagem('');
        setFormDrawerOpen(true);
    };

    const salvar = async () => {
        if (!nome || !String(nome).trim()) {
            setMensagem('Nome é obrigatório.');
            return;
        }
        setMensagem('');
        setMensagemTipo('danger');
        verificandoToken();
        const body = {
            nome: nome.trim(),
            descricao: (descricao || '').trim(),
            categoria_id: categoriaId !== '' ? Number(categoriaId) : null,
            codigo_legado: codigoLegado !== '' ? Number(codigoLegado) : null,
            ativo: Number(ativo),
            ordem: Number(ordem) || 0,
            usa_sprint: Number(usaSprint) || 0,
            emoji: (emoji || '').trim() || null,
            cor_card: (corCard || '').trim() || null
        };
        try {
            const res = id
                ? await updateTipoChamado(id, body)
                : await createTipoChamado(body);
            const msg = res?.data?.message || (id ? 'Tipo atualizado!' : 'Tipo adicionado!');
            const usadoFallback = res?.data?.usado_fallback_emoji_cor === true;
            setMensagemTipo(usadoFallback ? 'warning' : 'success');
            setMensagem(msg);
            if (!usadoFallback) {
                limparForm();
                setFormDrawerOpen(false);
            }
            load();
        } catch (e) {
            setMensagemTipo('danger');
            const msg = e?.response?.data?.error || e?.response?.data?.message || e?.message || 'Erro ao salvar.';
            setMensagem(msg);
        }
    };

    const excluir = (itemId, itemNome) => {
        setConfirmExcluir({ show: true, itemId, itemNome });
    };

    const executarExcluir = async () => {
        const { itemId: itemIdToDelete } = confirmExcluir;
        setConfirmExcluir({ show: false, itemId: null, itemNome: '' });
        if (!itemIdToDelete) return;
        verificandoToken();
        try {
            await deleteTipoChamado(itemIdToDelete);
            load();
            if (id === itemIdToDelete) { limparForm(); setFormDrawerOpen(false); }
        } catch (e) {
            setMensagem(e?.response?.data?.message || 'Erro ao excluir.');
        }
    };

    const abrirModalDuplicar = async () => {
        setMensagemDuplicar('');
        setSelectedIds([]);
        setEmpresaDestinoId('');
        try {
            const list = await fetchEmpresas();
            setEmpresasList(Array.isArray(list) ? list.filter((e) => Number(e.id) !== 1) : []);
        } catch (e) {
            setMensagemDuplicar('Erro ao carregar empresas.');
        }
        setShowModalDuplicar(true);
    };

    const toggleSelecaoDuplicar = (itemId) => {
        setSelectedIds((prev) => (prev.includes(itemId) ? prev.filter((x) => x !== itemId) : [...prev, itemId]));
    };

    const selecionarTodosDuplicar = () => {
        const ids = filtrado.map((t) => t.id);
        setSelectedIds(ids.length === selectedIds.length ? [] : ids);
    };

    const solicitarConfirmacaoDuplicar = () => {
        const destId = Number(empresaDestinoId);
        if (!destId || selectedIds.length === 0) {
            setMensagemDuplicar('Selecione ao menos um item e a empresa destino.');
            return;
        }
        const emp = empresasList.find((e) => Number(e.id) === destId);
        const nomeEmpresa = emp ? emp.nome : `ID ${destId}`;
        setConfirmDuplicar({ show: true, count: selectedIds.length, nomeEmpresa });
    };

    const confirmarDuplicar = async () => {
        setConfirmDuplicar({ show: false, count: 0, nomeEmpresa: '' });
        const destId = Number(empresaDestinoId);
        if (!destId || selectedIds.length === 0) return;
        setLoadingDuplicar(true);
        setMensagemDuplicar('');
        verificandoToken();
        try {
            await duplicarTiposChamadoParaEmpresa(selectedIds, destId);
            setShowModalDuplicar(false);
            load();
        } catch (e) {
            setMensagemDuplicar(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao duplicar.');
        } finally {
            setLoadingDuplicar(false);
        }
    };

    const porBusca = !busca.trim()
        ? data
        : data.filter((t) =>
            String(t.nome || '').toLowerCase().includes(busca.toLowerCase()) ||
            String(t.descricao || '').toLowerCase().includes(busca.toLowerCase())
        );
    const filtrado = filtroAtivo === 'todos'
        ? porBusca
        : porBusca.filter((t) => (filtroAtivo === 'ativo' ? t.ativo : !t.ativo));

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado">
                    <div className="page-header">
                        <h1>Cadastro de Tipos de Chamado</h1>
                        <div className="toolbar flex-wrap">
                            <div className="input-group input-group-sm" style={{ maxWidth: 280 }}>
                                <input value={busca} onChange={(e) => setBusca(e.target.value)} type="text" className="form-control" placeholder="Pesquisar" />
                            </div>
                            <select value={filtroAtivo} onChange={(e) => setFiltroAtivo(e.target.value)} className="form-control form-control-sm" style={{ maxWidth: 140 }} title="Filtrar por status">
                                <option value="todos">Todos</option>
                                <option value="ativo">Ativos</option>
                                <option value="inativo">Inativos</option>
                            </select>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => { limparForm(); setFormDrawerOpen(true); }}>
                                Novo tipo
                            </button>
                            {isEmpresa1() && (
                                <button type="button" className="btn btn-outline-primary btn-sm" onClick={abrirModalDuplicar} title="Duplicar cadastros para outra empresa">
                                    Duplicar para outra empresa
                                </button>
                            )}
                        </div>
                    </div>
                    <CadastroFormDrawer
                        open={formDrawerOpen}
                        onClose={() => { limparForm(); setFormDrawerOpen(false); }}
                        title={id ? 'Editar tipo de chamado' : 'Novo tipo de chamado'}
                    >
                        <div className="cadastro-form-drawer-form">
                            <div className="form-group">
                                <label>Nome</label>
                                <input value={nome} onChange={(e) => setNome(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Descrição</label>
                                <input value={descricao} onChange={(e) => setDescricao(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label className="d-flex align-items-center gap-2">
                                    <input type="checkbox" checked={usaSprint === 1} onChange={(e) => setUsaSprint(e.target.checked ? 1 : 0)} />
                                    Usa sprint
                                </label>
                                <small className="text-muted">Tipos com sprint são controlados pela Sprint (sem SLA). O SLA é definido em Config → Políticas de SLA.</small>
                            </div>
                            <div className="form-group">
                                <label>Categoria</label>
                                <select value={categoriaId} onChange={(e) => setCategoriaId(e.target.value)} className="form-control form-control-sm">
                                    <option value="">Nenhuma</option>
                                    {categorias.map((c) => (
                                        <option key={c.id} value={c.id}>{c.nome}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Código legado (SATTIP)</label>
                                <input type="number" value={codigoLegado} onChange={(e) => setCodigoLegado(e.target.value)} className="form-control form-control-sm" placeholder="Opcional" />
                            </div>
                            <div className="form-group">
                                <label>Ordem</label>
                                <input type="number" value={ordem} onChange={(e) => setOrdem(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Ativo</label>
                                <select value={ativo} onChange={(e) => setAtivo(e.target.value)} className="form-control form-control-sm">
                                    <option value={1}>Sim</option>
                                    <option value={0}>Não</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Emoji (ao lado do chamado na listagem)</label>
                                <div className="d-flex flex-wrap gap-2 align-items-center">
                                    <select value={emoji} onChange={(e) => setEmoji(e.target.value)} className="form-control form-control-sm" style={{ width: 'auto', minWidth: 80 }}>
                                        <option value="">Nenhum</option>
                                        {['📞', '🐛', '✨', '📋', '🔧', '🖥️', '📱', '⚠️', '🎯', '📦', '🔒', '🌐', '💡', '📊', '🚀', '📝', '🔴', '🟢', '🟡', '💻', '🛠️', '📌', '✅', '❌'].map((em) => (
                                            <option key={em} value={em}>{em}</option>
                                        ))}
                                    </select>
                                    {emoji && <span style={{ fontSize: '1.2rem' }}>{emoji}</span>}
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Cor do card (na listagem)</label>
                                <div className="d-flex flex-wrap gap-2 align-items-center">
                                    <input type="color" value={corCard && /^#[0-9A-Fa-f]{6}$/.test(corCard) ? corCard : '#2563eb'} onChange={(e) => setCorCard(e.target.value)} className="form-control form-control-sm p-1" style={{ width: 40, height: 32 }} title="Cor do card" />
                                    <input type="text" value={corCard} onChange={(e) => setCorCard(e.target.value)} className="form-control form-control-sm" placeholder="#2563eb" style={{ maxWidth: 100 }} />
                                </div>
                            </div>
                            {mensagem && <div className={`alert py-2 mb-2 alert-${mensagemTipo}`}>{mensagem}</div>}
                            <div className="cadastro-form-drawer-form__actions">
                                <button onClick={() => { limparForm(); setFormDrawerOpen(false); }} type="button" className="btn btn-secondary btn-sm">Cancelar</button>
                                <button onClick={salvar} type="button" className="btn btn-primary btn-sm">Salvar</button>
                            </div>
                        </div>
                    </CadastroFormDrawer>
                    <div className="lista-wrapper">
                        {loading ? (
                            <p className="text-muted">Carregando...</p>
                        ) : (
                            <table className="table table-modern align-middle">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Nome</th>
                                        <th>Emoji</th>
                                        <th>Cor card</th>
                                        <th>Sprint</th>
                                        <th>Categoria</th>
                                        <th>Legado</th>
                                        <th>Ordem</th>
                                        <th>Ativo</th>
                                        <th width="120">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtrado.length === 0 && !loading && (
                                        <tr><td colSpan="10" className="text-center text-muted">Nenhum tipo cadastrado.</td></tr>
                                    )}
                                    {filtrado.map((t) => (
                                        <tr key={t.id} className="table-row-clickable" onClick={() => handleEdit(t)}>
                                            <td>{t.id}</td>
                                            <td>{t.nome}</td>
                                            <td>{t.emoji ? <span style={{ fontSize: '1.1rem' }}>{t.emoji}</span> : '-'}</td>
                                            <td>{t.cor_card ? <span className="d-inline-block rounded border" style={{ width: 20, height: 20, backgroundColor: t.cor_card }} title={t.cor_card} /> : '-'}</td>
                                            <td>{t.usa_sprint ? 'Sim' : '-'}</td>
                                            <td>{categorias.find((c) => c.id === t.categoria_id)?.nome || '-'}</td>
                                            <td>{t.codigo_legado != null ? t.codigo_legado : '-'}</td>
                                            <td>{t.ordem != null ? t.ordem : '-'}</td>
                                            <td><span className={t.ativo ? 'badge-pill badge-ativo' : 'badge-pill badge-inativo'}>{t.ativo ? 'Sim' : 'Não'}</span></td>
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <button type="button" className="btn btn-secondary btn-sm me-1" onClick={() => handleEdit(t)} title="Editar"><i className="fas fa-edit" /></button>
                                                <button type="button" className="btn btn-danger btn-sm" onClick={(e) => { e.stopPropagation(); excluir(t.id, t.nome); }} title="Excluir"><i className="fas fa-trash" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {showModalDuplicar && (
                        <div className="modal-overlay" onClick={() => !loadingDuplicar && setShowModalDuplicar(false)}>
                            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                                <h5 className="mb-3">Duplicar tipos de chamado para outra empresa</h5>
                                <p className="text-muted small mb-2">Selecione os itens e a empresa destino. Apenas cadastros da empresa Softbridge (1) serão copiados. A categoria ficará em branco na empresa destino.</p>
                                <div className="mb-3">
                                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={selecionarTodosDuplicar}>
                                        {filtrado.length > 0 && selectedIds.length === filtrado.length ? 'Desmarcar todos' : 'Selecionar todos'}
                                    </button>
                                </div>
                                <div className="mb-3" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                    {filtrado.map((t) => (
                                        <div key={t.id} className="form-check">
                                            <input type="checkbox" className="form-check-input" id={`dup-tipo-${t.id}`} checked={selectedIds.includes(t.id)} onChange={() => toggleSelecaoDuplicar(t.id)} />
                                            <label className="form-check-label" htmlFor={`dup-tipo-${t.id}`}>{t.nome}</label>
                                        </div>
                                    ))}
                                    {filtrado.length === 0 && <span className="text-muted">Nenhum item na lista.</span>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Empresa destino</label>
                                    <select className="form-select form-select-sm" value={empresaDestinoId} onChange={(e) => setEmpresaDestinoId(e.target.value)}>
                                        <option value="">Selecione...</option>
                                        {empresasList.map((e) => (
                                            <option key={e.id} value={e.id}>{e.nome || `Empresa ${e.id}`}</option>
                                        ))}
                                    </select>
                                </div>
                                {mensagemDuplicar && <div className="alert alert-danger py-2 mb-2">{mensagemDuplicar}</div>}
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowModalDuplicar(false)} disabled={loadingDuplicar}>Cancelar</button>
                                    <button type="button" className="btn btn-primary btn-sm" onClick={solicitarConfirmacaoDuplicar} disabled={loadingDuplicar}>{loadingDuplicar ? 'Duplicando...' : 'Duplicar'}</button>
                                </div>
                            </div>
                        </div>
                    )}

                    <ModalConfirm
                        open={confirmExcluir.show}
                        onClose={() => setConfirmExcluir({ show: false, itemId: null, itemNome: '' })}
                        title="Excluir tipo"
                        message={`Excluir o tipo "${confirmExcluir.itemNome}"?`}
                        confirmLabel="Sim, excluir"
                        cancelLabel="Cancelar"
                        onConfirm={executarExcluir}
                        variant="danger"
                    />
                    <ModalConfirm
                        open={confirmDuplicar.show}
                        onClose={() => setConfirmDuplicar({ show: false, count: 0, nomeEmpresa: '' })}
                        title="Duplicar para empresa"
                        message={`Deseja duplicar ${confirmDuplicar.count} item(ns) para a empresa "${confirmDuplicar.nomeEmpresa}"?`}
                        confirmLabel="Sim, duplicar"
                        cancelLabel="Cancelar"
                        onConfirm={confirmarDuplicar}
                        variant="primary"
                    />
                </div>
            </main>
        </div>
    );
}

export default TiposChamado;
